export const AUTH_CONFIG = {
  // Base64 encoded credentials
  credentials: [
    {
      username: "ZGVtbw==", // "demo" encoded
      password: "cGFzc3dvcmQ=", // "password" encoded
      requireMFA: false,
    },
    {
      username: "bWZhdXNlcjAwMQ==", // "mfauser001" encoded
      password: "dHJ1dXRoZmFpcnk=", // "truuthfairy" encoded
      requireMFA: true,
    },
    // Add more credential pairs as needed
  ],
  messages: {
    invalidCredentials: "Invalid credentials",
    missingCredentials: "Enter username and password",
  },
};

// Helper function to decode credentials
export const decodeCredential = (encoded: string): string => {
  try {
    return atob(encoded);
  } catch {
    return "";
  }
};

// Helper function to validate credentials against the allowed list
export const validateCredentials = (
  username: string,
  password: string
): { isValid: boolean; requireMFA: boolean } => {
  const matchedCred = AUTH_CONFIG.credentials.find(
    (cred) =>
      decodeCredential(cred.username) === username &&
      decodeCredential(cred.password) === password
  );

  if (!matchedCred) {
    return {
      isValid: false,
      requireMFA: false,
    };
  }

  return {
    isValid: true,
    requireMFA: matchedCred.requireMFA,
  };
};
